<template>
	<div>
	<el-dialog
	  title="发布订单"
	  :visible.sync="dialogVisible"
	  width="30%"
	 >
	  <el-form ref="form" :model="form" :rules="rules" size="small" label-width="80px" style="text-align: left;">
	  
	    <el-form-item label="任务名称" prop="orderName">
	      <el-input v-model="form.orderName" style="width: 250px;" />
	    </el-form-item>
	    <el-form-item label="订单描述" prop="orderDescribe">
	      <el-input :rows="2" v-model="form.orderDescribe" type="textarea" style="width: 250px;" />
	    </el-form-item>
	    <el-form-item label="订单类型" prop="orderType">
	      <el-select v-model="form.orderType" placeholder="请选择订单类型">
	          <el-option v-for="item in dictMap.order_type"
	             :key="item.value" :label="item.label" :value="item.value"/>
	      </el-select>
	    </el-form-item>
	    <el-form-item label="发布方式" prop="releaseType">
	      <el-radio-group v-model="form.releaseType">
	        <el-radio v-for="(item,index) in dictMap.release_type" :key = "index" :label="item.value">{{item.label}}</el-radio>
	      </el-radio-group>
	  
	    </el-form-item>
	    <el-form-item label="发布模式" prop="releasePattern">
	     <el-radio-group v-model="form.releasePattern">
	       <el-radio v-for="(item,index) in dictMap.release_pattern" :key = "index" :label="item.value">{{item.label}}</el-radio>
	     </el-radio-group>
	    </el-form-item>
	    <el-form-item label="核算系数" prop="orderCoefficient">
	      <el-input v-model="form.orderCoefficient" style="width: 250px;" />
	    </el-form-item>
		<el-form-item label="绩效系数" prop="performancefeesCoefficient">
		  <el-input v-model="form.performancefeesCoefficient" style="width: 250px;" />
		</el-form-item>
	   
	    <el-form-item label="供应商" prop="yumiSupplier">
	      <el-select v-model="form.yumiSupplier" value-key="id" placeholder="请选择供应商">
	        <div v-for="item in supplierList" :key="item.id">
	          <el-option :label="item.supplierName" :value="item"/>
	        </div>
	      </el-select>
	    </el-form-item>

	    <el-form-item label="发布时间" prop="releaseTime">
	      <el-date-picker v-model="form.releaseTime" type="datetime" style="width: 250px;" />
	    </el-form-item>

	    <el-form-item label="结算价格" prop="settlementPrice">
	      <el-input v-model.number="form.settlementPrice" type="float" style="width: 250px;" />
	    </el-form-item>
	    <el-form-item label="应发供应商绩效费（含税）" prop="performanceFees">
	      <el-input v-model.number="form.performanceFees" disabled="true" style="width: 250px;" />
	    </el-form-item>
	    <el-form-item label="交付时间" prop="deliveryTime">
	      <el-date-picker v-model="form.deliveryTime" type="datetime" style="width: 250px;" />
	    </el-form-item>

	  
	  </el-form>
	  <h4>
	    <p>关于任务描述的书写规则：</p>
	    <p>1、任务描述：详细，与真实业务匹配上，不能虚假。</p>
	    <p>2、任务时间：要合理、与金额、任务描述要匹配。</p>
	    <p>3、任务金额：要合理、与真实业务匹配。</p>
	    <p>平台内任务承揽的法律依据为《中华人民共和国合同法》</p>
	    <p>第二百五十一条：承揽合同是承揽人按照定作人的要求完成工作，交付工作成果，定作人给付报酬的合同。 承揽包括加工、定作、修理、复制、测试、检验等工作。</p>
	    <p>第二百五十二条： 承揽合同的内容包括承揽的标的、数量、质量、报酬、承揽方式、材料的提供、履行期限、验收标准和方法等条款。</p>
	    <p>第二百五十三条： 承揽人应当以自己的设备、技术和劳力，完成主要工作，但当事人另有约定的除外。 承揽人将其承揽的主要工作交由第三人完成的，应当就该第三人完成的工作成果向定作人负责；未经定作人同意的，定作人也可以解除合同。</p>
	  </h4>
	<span slot="footer" class="dialog-footer">
	    <el-button @click="dialogVisible = false">取 消</el-button>
	    <el-button type="primary" @click="doSubmit">发 布</el-button>
	  </span>
	</el-dialog>
	</div>
</template>

<script>
	import initDict from '@/mixins/initDict'
	import {enterpriseAdd} from '../../../api/company.js'
	export default{
		
		 mixins: [ initDict],
	
		data(){
			var checkSettlementPrice = (rule, value, callback) => {
			  const pattern = /^(([^0][0-9]+|0)\.([0-9]{1,2}))$/
			  const pattern2 = /^([^0][0-9]+|0)$/
			  if (pattern.test(value)) {
			    this.form.performanceFees = (Number(this.form.settlementPrice) * Number(this.form.performancefeesCoefficient)).toFixed(2)
			
			    callback()
			  } else {
			    if (pattern2.test(value)) {
			      this.form.performanceFees = (Number(this.form.settlementPrice) * Number(this.form.performancefeesCoefficient)).toFixed(2)
			      this.form.settlementPrice = this.form.settlementPrice + '.00'
			      callback()
			    } else {
			      callback(new Error('格式错误,必须为数字类型,最多2位小数'))
			    }
			  }
			}
			var checkorderCoefficient = (rule, value, callback) => {
			  const pattern = /^([0]{1}\.\d{1,2})$/
			  if (pattern.test(value)) {
			    callback()
			  } else {
			    callback(new Error('格式错误,必须是2位小数'))
			  }
			}
			
			// var checkorderCoefficient = (rule, value, callback) => {
			//   const pattern = /^([1]{1}\.\d{1,2})$/
			//   if (pattern.test(value)) {
			//     callback()
			//   } else {
			//     callback(new Error('格式错误,必须大于1'))
			//   }
			// }
			
			var checkperformanceFees = (rule, value, callback) => {
			  const pattern = /^(([^0][0-9]+|0)\.([0-9]{1,2}))$/
			  const pattern2 = /^([^0][0-9]+|0)$/
			  if (pattern.test(value)) {
			    callback()
			  } else {
			    if (pattern2.test(value)) {
			      this.form.performanceFees = this.form.performanceFees + '.00'
			      callback()
			    } else {
			      callback(new Error('格式错误,必须为数字类型'))
			    }
			  }
			}
			return {
				supplierList:[],
				dialogVisible: false,
				form: {
				  id: '',
				  orderName: '',
				  orderDescribe: '',
				  orderType: '',
				  releaseType: 'assign',
				  releasePattern: 'sendOrder',
				  settlementAccountId: '',
				  supplierId: '',
				  enterpriseId: '',
				  releaseTime: '',
				  createDateTime: '',
				  performanceFees: '',
				  orderCoefficient:'',
				  performancefeesCoefficient:'1.067',
				  deliveryTime: '',
				  orderStatus: '',
				  settlementPrice: '',
				  orderNumber: '',
				  yumiSupplier:null
				},
				rules: {
				  orderName: [{
				    required: true,
				    trigger: 'blur',
				    message: '订单名称不能为空'
				  }],
				  orderDescribe: [{
				    required: true,
				    trigger: 'blur',
				    message: '订单描述不能为空'
				  }],
				  orderType: [{
				    required: true,
				    trigger: 'change',
				    message: '请选择订单类型'
				  }],
				  settlementAccountId: [{
				    required: true,
				    trigger: 'change',
				    message: '请选择账套'
				  }],
				  orderCoefficient: [{
				    required: true,
				    validator: checkorderCoefficient,
				    trigger: 'blur'
				  }],
				  // yumiSupplier: [{
				  //   required: true,
				  //   trigger: 'change',
				  //   message: '请选择供应商'
				  // }],
				  releaseTime: [{
				    required: true,
				    trigger: 'change',
				    message: '请设置发布时间'
				  }],
				  performanceFees: [{
				    required: true,
				    message: '绩效不能为空',
				    trigger: 'blur'
				  }],
				  deliveryTime: [{
				    required: true,
				    trigger: 'change',
				    message: '请设置完成时间'
				  }],
				  settlementPrice: [{
				    required: true,
				    validator: checkSettlementPrice,
				    trigger: 'blur'
				  }]
				}
			}
			
			
		},
		created() {
		
			this.getDictMap('order_type,settlement_account,order_status,release_type,release_pattern')
		},
		methods:{
			
			doSubmit() {
			this.dialogVisible = false
			  this.$refs['form'].validate((valid) => {
			    if (valid) {
			      enterpriseAdd(this.form).then(res => {
			        this.$notify({
			          title: '发布成功',
			          type: 'success',
			          duration: 2500
			        })
			        this.loading = false
			        this.dialog = false
			        this.$parent.$parent.init()
			      }).catch(err => {
			        this.loading = false
			        console.log(err.response.data.message)
			      })
			    } else {
			      this.$notify({
			        title: '提交失败',
			        type: 'error',
			        duration: 2500
			      })
			      this.loading = false
			      return false
			    }
			    this.loading = false
			  })
			},
			
		}
		
		
		
	}
</script>

<style>
	.el-form-item__label{
		
		margin-right: 24px;
		
	}
</style>
